import { Col, Row, Select, Button, Tooltip } from "antd";
import { MailOutlined, LinkOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import LabelValor from "../../../../components/label/LabelValor";
import { CalificarEstrellas } from "./CalificarEstrellas";
import { EstatusProveedor } from "./EstatusProveedor";
import {
  entidadesFederativas,
  regimeArray,
} from "../../../../utils/provedorUtils";
import LabelIcon from "../../../../components/label/LabelIcon";
import { dateFromString } from "../../../../utils/dateFromString";
import { startSendEmailUpdateLink, startGetProveedor } from "../../../../context/actions/proveedoresActions";
import { notification } from "../../../../context/actions/notificationActions";
import { composeWarningNotification, composeErrorNotification, composeSuccessNotification } from "../../../../utils/composeNotification";
import { get, post } from "../../../../utils/fetch";
import { URL_BASE_DATOS_PROVEEDORES } from "../../../../constants/url";

export default function Info() {
  const dispatch = useDispatch();
  const {
    noExterior,
    noInterior,
    nombreColonia,
    nombreMunicipio,
    razonSocial,
    nombreComercial,
    rfc,
    contactoNombre,
    contactoTelefono1,
    contactoTelefono2,
    contactoTelefono3,
    contactoEmail,
    ivaRetenido,
    isrRetenido,
    apellidoMaterno,
    cp,
    nombreVialidad,
    tipoPersona,
    nombre,
    apellidoPaterno,
    regimenFiscalId,
    entidadFederativa,
    iva,
    estrellas,
    esProveedorInterno,
    esProveedorCritico,
    fechaContrato,
    proveedorID,
    usuarioAsignadoID,
    contactoOperaciones,
    emailOperaciones,
    telefonoOperaciones1
  } = useSelector((state) => state.proveedoresReducer.proveedor);

  const { enviandoEmailProveedor } = useSelector((state) => state.proveedoresReducer);

  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [asignandoEjecutivo, setAsignandoEjecutivo] = useState(false);

  useEffect(() => {
    fetchUsuarios();
  }, []);

  useEffect(() => {
    if (usuarioAsignadoID) {
      setSelectedUsuario(usuarioAsignadoID);
    }
  }, [usuarioAsignadoID]);

  /////
  const personaString =
    tipoPersona === 0
      ? ""
      : tipoPersona === 1
      ? "Física"
      : tipoPersona === 2
      ? "Moral"
      : "";
  const regimen = regimeArray.filter((r) => r.value === regimenFiscalId);
  const entidad = entidadesFederativas.filter(
    (e) => e.value === entidadFederativa
  );

  const handleEnviarEmail = () => {
    dispatch(startSendEmailUpdateLink());
  };

  const fetchUsuarios = async () => {
    setLoadingUsuarios(true);
    const url = `${URL_BASE_DATOS_PROVEEDORES}/GetUsuariosAreaProveedores`;
    const result = await get(url);

    if (result.code === 0) {
      const usuariosOptions = result.data.map((usuario) => ({
        value: usuario.usuarioID,
        label: usuario.nombre,
      }));
      setUsuarios(usuariosOptions);
    }
    setLoadingUsuarios(false);
  };

  const handleAsignarEjecutivo = async () => {
    if (!selectedUsuario) {
      dispatch(notification(composeWarningNotification("Por favor seleccione un usuario")));
      return;
    }

    setAsignandoEjecutivo(true);
    const url = `${URL_BASE_DATOS_PROVEEDORES}/SetProveedorUsuario`;
    const result = await post(url, { proveedorID, usuarioID: selectedUsuario });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      dispatch(startGetProveedor(proveedorID));
      setSelectedUsuario(null);
    }
    setAsignandoEjecutivo(false);
  };

  return (
    <>
      <EstatusProveedor />

      {tipoPersona === 1 && (
        <Row gutter={[10, 10]} style={{ marginBottom: 20 }}>
          <Col span={5}>
            <LabelValor label="Nombre" valor={nombre} />
          </Col>
          <Col span={5}>
            <LabelValor label="Apellido Paterno" valor={apellidoPaterno} />
          </Col>
          <Col span={5}>
            <LabelValor label="Apello Materno" valor={apellidoMaterno} />
          </Col>
        </Row>
      )}

      {/*--------------------- */}
      <Row gutter={[10, 10]} style={{ marginBottom: 10, marginTop: 10 }}>
        <Col span={5}>
          <LabelValor label="Nombre comercial" valor={nombreComercial} />
        </Col>
        <Col span={5}>
          <LabelValor label="Razón social" valor={razonSocial} />
        </Col>
        <Col span={5}>
          <LabelValor label="RFC" valor={rfc} />
        </Col>
        <Col span={5}>
          <LabelValor label="Contacto" valor={contactoNombre} />
        </Col>
      </Row>
      <Row gutter={[10, 10]} style={{ marginBottom: 10 }}>
        <Col span={5}>
          <LabelValor label="Email" valor={contactoEmail} />
        </Col>

        <Col span={5}>
          <LabelValor label="Teléfono 1" valor={contactoTelefono1} />
        </Col>
        <Col span={5}>
          <LabelValor label="Teléfono 2" valor={contactoTelefono2} />
        </Col>
        <Col span={5}>
          <LabelValor label="Teléfono 3" valor={contactoTelefono3} />
        </Col>
      </Row>
      <Row gutter={[10, 10]} style={{ marginBottom: 20 }}>
        <Col span={5}>
          <LabelValor label="IVA" valor={iva} />
        </Col>
        <Col span={5}>
          <LabelValor label="IVA retenido" valor={ivaRetenido} />
        </Col>
        <Col span={5}>
          <LabelValor label="ISR Retenido" valor={isrRetenido} />
        </Col>
        <Col span={5}>
          <CalificarEstrellas estrellas={estrellas} />
        </Col>
      </Row>

      {/*Campos nuevos agregado by Luis M. Z*/}
      <Row gutter={[10, 10]} style={{ marginBottom: 20 }}>
        <Col span={5}>
          <LabelValor label="Codigo Postal" valor={cp} />
        </Col>
        <Col span={5}>
          <LabelValor label="Tipo de Persona" valor={personaString} />
        </Col>
        <Col span={10}>
          <LabelValor label="Regimen Fiscal" valor={regimen[0]?.label} />
        </Col>

        <Col span={5}>
          <LabelValor label="Entidad Federartiva" valor={entidad[0]?.label} />
        </Col>
        {/*Calle, número, apartamento. Código postal + Localidad + Departamento.*/}
        <Col span={15}>
          <LabelValor
            label="Dirección Completa"
            valor={`${nombreVialidad} ${noExterior}, int  ${noInterior}, ${cp},${nombreColonia}, ${nombreMunicipio}  ${entidad[0]?.label}`}
          />
        </Col>
      </Row>
      <Row gutter={[10, 10]} style={{ marginBottom: 20 }}>
        <Col span={5}>
          <LabelValor label="Nombre Contacto Operativo" valor={contactoOperaciones} />
        </Col>
        <Col span={5}>
          <LabelValor label="Email Contacto Operativo" valor={emailOperaciones} />
        </Col>
        <Col span={5}>
          <LabelValor label="Teléfono Contacto Operativo" valor={telefonoOperaciones1} />
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={4}>
          <LabelIcon label="Proveedor Interno" valor={esProveedorInterno} />
        </Col>
        <Col span={4}>
          <LabelIcon label="Proveedor Crítico" valor={esProveedorCritico} />
        </Col>
        <Col span={4}>
          <LabelValor label="Fecha Contrato" valor={dateFromString(fechaContrato).soloFecha} />
        </Col>
      </Row>
      <Row gutter={10} style={{ marginTop: 20, alignItems: "flex-end" }}>
        <Col span={3}>
          <div style={{ marginBottom: 8, fontSize: 14, fontWeight: 500, color: "#666" }}>
            Enviar enlace
          </div>
          <Tooltip
            title="Enviar enlace para actualizar datos"
            overlayStyle={{ whiteSpace: 'nowrap' }}
          >
            <Button
              type="default"
              onClick={handleEnviarEmail}
              loading={enviandoEmailProveedor}
              disabled={!contactoEmail || contactoEmail.trim() === ""}
            >
              <LinkOutlined />
              <MailOutlined style={{ marginLeft: 4 }} />
            </Button>
          </Tooltip>
        </Col>
        <Col span={5}>
          <div style={{ marginBottom: 8, fontSize: 14, fontWeight: 500, color: "#666" }}>
            Ejecutivo
          </div>
          <Select
            value={selectedUsuario}
            onChange={(value) => setSelectedUsuario(value)}
            placeholder="Seleccione ejecutivo"
            style={{ width: "100%" }}
            options={usuarios}
            loading={loadingUsuarios}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Col>
        <Col span={5}>
          <Button
            type="primary"
            onClick={handleAsignarEjecutivo}
            loading={asignandoEjecutivo}
            disabled={!selectedUsuario}
            style={{ marginBottom: 0 }}
          >
            Asignar ejecutivo
          </Button>
        </Col>
      </Row>
    </>
  );
}
